import {
    Component } from '@angular/core';

@Component({
    selector: 'itpx-dashboard',
    templateUrl: './dashboard.component.html'
})
export class CommunicationDashboardComponent {
    private tiles: Array<any> = [
        {
            title: 'Emails',
            redirectPath: 'emails',
            description: 'Manage your emails',
            icon: 'fa-envelope',
            color: 'blue'
        }, {
            title: 'Templates',
            redirectPath: 'templates',
            description: 'Manage your templates',
            icon: 'fa-file',
            color: 'green'
        }
    ];
    constructor() { }
}



// WEBPACK FOOTER //
// ./src/app/organization/components/communication/components/dashboard/dashboard.component.ts